// libraries
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, CardBody, CardTitle } from "reactstrap";
// styles
import { lkGreen, lkRed, lkWhite } from "../Utility/styleComponents";
import Spinner from "../Utility/Spinner";
import { connect } from "react-redux";

const FaultBar = (props) => {
  const { faultData, dbFilter, layoutType } = props;
  const { dateRange, location } = dbFilter;
  const [series, setSeries] = useState([]);
  let faultBarDataYear1 = Array(11).fill(0);
  let faultBarDataYear2 = Array(11).fill(0);
  const category = [
    "OverCurrentFailure",
    "OverVoltage",
    "UnderVoltage",
    "PowerSwitchFailure",
    "GroundFailure",
    "ReaderFailure",
    "PowerMeterFailure",
    "HighTemperature",
    "InternalError",
    "PBoardFailure",
    "OtherError",
  ];
  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: layoutType === "vertical" ? "20pt" : "6px",
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: 15,
      style: {
        fontSize: "9px",
        colors: [lkWhite],
      },
    },
    stroke: {
      show: true,
      width: 0.5,
      colors: [lkWhite],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    colors: [lkRed, lkGreen],
    grid: {
      borderColor: "#f1f1f1",
    },
    // xaxis: {
    // },
    xaxis: {
      categories: category,

      labels: {
        style: {
          fontSize: layoutType === "vertical" ? "13px" : "10px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: layoutType === "vertical" ? "13px" : "10px",
        },
      },
    },
  };
  useEffect(() => {
    filterSeriesOnDate();
  }, [dateRange, faultData, location]);

  const extractErrorCode = (details) => {
    // split the details string based on ","
    const detailsArray = details?.split(",");
    // split the errorcode to get the error
    const errorCodeRaw = detailsArray[0]?.split("=")[1]?.trim();
    // if errorcode is other error, check vendor error code
    if (errorCodeRaw === "OtherError") {
      // fetch the vendor error code
      const vendorErrorCode = detailsArray[2]?.split("=")[1]?.trim();
      // check if the vendor error code exists in the pre defined array
      // if exists, then return vendorErrorCode
      return category.includes(vendorErrorCode) ? vendorErrorCode : errorCodeRaw;
    }
    return errorCodeRaw;
  };
  // to filter the series based on the selected date range
  const filterSeriesOnDate = () => {
    const year1 = new Date(dateRange[0]).getFullYear();
    const year2 = new Date(dateRange[1]).getFullYear();

    if (faultData?.length === 0) {
      return;
    }
    let chargersInSelectedLocation = [];
    if (location?.length > 0) {
      // chargersInSelectedLocation = props.chargerToLocationMap[location] || [];
      const chargersInSelectedLoc = props.chargerToLocationMap[location] || [];
      chargersInSelectedLocation = chargersInSelectedLoc?.map((item) => item?.id) || [];
    }

    const startDate = new Date(dateRange[0]).getTime();
    const endDate = new Date(dateRange[1]).getTime();
    // filter the transaction for the selected date range
    let filteredStatus = [];
    filteredStatus = faultData?.filter((status) => {
      const statusTime = new Date(status.timeStamp).getTime();
      if (location?.length === 0) {
        return statusTime >= startDate && statusTime <= endDate;
      }
      return statusTime >= startDate && statusTime <= endDate && chargersInSelectedLocation?.includes(status?.chargerId);
    });
    console.log("filteredStatus: ", filteredStatus);
    //Sort by StartTime
    filteredStatus.sort((a, b) => {
      if (a.timeStamp && b.timeStamp) {
        return -a.timeStamp.localeCompare(b.timeStamp);
      }
      return 0; // or handle as necessary if timeStamp is missing
    });

    // if the selected date range spans across 2 years, if loop will be executed,
    // if selected date range is in only one year then else loop will be executed
    // Existing logic can render the data when selected  at max between 2 years
    if (year1 !== year2) {
      filteredStatus.forEach((item) => {
        const { timeStamp, details } = item;
        const faultDate = new Date(timeStamp);
        const year = faultDate.getFullYear();

        const errorCode = extractErrorCode(details);
        // check whether the error code exists in the pre-defined errors Array
        const isExists = category?.includes(errorCode);
        // if exists then increment the corresponding errorcode
        if (isExists) {
          const index = category.indexOf(errorCode);
          if (year === year1) {
            faultBarDataYear1[index] += 1;
          } else if (year === year2) {
            faultBarDataYear2[index] += 1;
          }
        }
      });
      const data = [
        {
          name: year1,
          data: faultBarDataYear1,
        },
        {
          name: year2,
          data: faultBarDataYear2,
        },
      ];
      setSeries(data);
    } else {
      filteredStatus.forEach((item) => {
        const { timeStamp, details } = item;
        const errorCode = extractErrorCode(details);
        // check whether the error code exists in the pre-defined errors Array
        const isExists = category?.includes(errorCode);
        // if exists then increment the errorcode
        if (isExists) {
          const index = category.indexOf(errorCode);
          faultBarDataYear1[index] += 1;
        }
      });
      const data = [
        {
          name: year1,
          data: faultBarDataYear1,
        },
      ];
      setSeries(data);
    }
  };

  return (
    <React.Fragment>
      <Card>
        <CardBody className={`${layoutType === "horizontal" && "m-0 p-0"}`}>
          <CardTitle className={`card-title ${layoutType === "vertical" ? "mb-4" : "m-2"}`}>Fault Bar</CardTitle>
          {series && series?.length > 0 ? (
            <ReactApexChart options={options} series={series} type="bar" height="351" />
          ) : (
            <div style={{ height: "365px" }}>
              <Spinner />
            </div>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  chargerToLocationMap: state?.sharedData?.chargerToLocationMap,
  layoutType: state.Layout.layoutType,
});

export default connect(mapStateToProps)(FaultBar);
